// extracted by mini-css-extract-plugin
export default {"container":"ukunVxEpzEG8Tj7rP6SV","info":"FTZkieu4ePzGPyXelP2c"};